import React from "react";
import { BandwidthHookInterface } from "../useBandwidthHook";
import Input from "./Input";
import { useLogs } from "../logsHook";
import { areYouSure, wrapInDrawer } from "../../../utils/methods";
import { useOpenClose } from "../../../utils/hooks/OpenCloseHook";
import Button from "../../DesignSystem/button";
import BandwidthActionButton from "./BandwidthActionButton";
import { PortHookInterface } from "../portDetailsHook";
import { ProviderView } from "./ProviderView";
import OptionsMenu from "./BandwidthMenu";

interface BandwidthSectionProps {
  bandwidthProps: BandwidthHookInterface;
  portProps: PortHookInterface;
  otherPortProps: PortHookInterface;
}

const BandwidthSection: React.FC<BandwidthSectionProps> = ({ bandwidthProps, portProps, otherPortProps }) => {
  const logs = useLogs(bandwidthProps.logs);
  const providerView = useOpenClose();
  const logsView = useOpenClose();

  const resetButton = <Button variant="primary" text="Reset" onClick={() => bandwidthProps.reset()} disabled={!bandwidthProps.isNameOrDescriptionChanged} />;
  const sendButton = (
    <Button
      variant="primary"
      text="Save"
      onClick={() => bandwidthProps.submit()}
      disabled={!bandwidthProps.isNameOrDescriptionChanged}
      loading={bandwidthProps.loadingSubmit}
    />
  );
  return (
    <div className="bandwidth-container">
      <div className="inner">
        <Input
          value={bandwidthProps.description}
          setValue={bandwidthProps.setDescription}
          title="Bandwidth Description"
          onKeypress={() => bandwidthProps.submit()}
          placeholder={portProps.portDetails && otherPortProps.portDetails ? portProps.portDetails.ne_name + " <> " + otherPortProps.portDetails.ne_name : ""}
        />
        <Input value={bandwidthProps.name} setValue={bandwidthProps.setName} title="Bandwidth Name" onKeypress={() => bandwidthProps.submit()} />
        <div className="flex edit-buttons">
          {resetButton}
          {sendButton}
        </div>
        <OptionsMenu portProps={portProps} otherPortProps={otherPortProps} bandwidthProps={bandwidthProps} />
      </div>
      {wrapInDrawer(logs, logsView.isOpen, () => logsView.close(), true)}
      {wrapInDrawer(
        <ProviderView portProps={portProps} rollService={bandwidthProps.rollService} isBandwidth />,
        providerView.isOpen,
        () => providerView.close(),
        true
      )}
    </div>
  );
};

export default BandwidthSection;
